var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "50",
      "height": "50",
      "viewBox": "0 0 67 67",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('circle', {
    attrs: {
      "cx": "33.5",
      "cy": "33.5",
      "r": "33.5",
      "fill": "#212121"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#fff",
      "stroke-width": "3",
      "stroke-linecap": "square",
      "d": "M21.5 24.5h10v16h-10zM31.5 41.335v-17.67l11-8.59v34.85l-11-8.59z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }